import { Tag } from "./Tag";
import { useKaya } from "../store/kayaStore";
// the button reset lives with the You page, whose header is this tag's main home
import "../pages/You.css";

/** "3 min ago" for the last sync; coarse on purpose, it is read at a glance. */
function since(at: number | null): string {
  if (!at) return "";
  const mins = Math.max(0, Math.round((Date.now() - at) / 60_000));
  if (mins < 1) return " just now";
  if (mins < 60) return ` ${mins} min ago`;
  const h = Math.round(mins / 60);
  return h < 24 ? ` ${h} h ago` : "";
}

/**
 * One-glance answer to "is my data anywhere but this phone?", as the kit's status Tag: synced is
 * the outline-with-a-check tag, a failure is caution, offline and syncing are neutral. A tap
 * syncs now; signed out it is a plain tag with nothing to press.
 */
export function SyncChip() {
  const { user, syncStatus, online, syncNow, lastSync } = useKaya();

  if (!user)
    return (
      <span title="Data is on this device only">
        <Tag tone="neutral">On this device</Tag>
      </span>
    );

  const offline = !online || syncStatus === "offline";
  const tag = offline ? (
    <Tag tone="neutral">Offline</Tag>
  ) : syncStatus === "syncing" ? (
    <Tag tone="neutral">Syncing…</Tag>
  ) : syncStatus === "error" ? (
    <Tag tone="est">Sync failed</Tag>
  ) : (
    <Tag tone="synced">{`Synced${since(lastSync)}`}</Tag>
  );

  return (
    <button
      type="button"
      className="you-sync"
      onClick={() => void syncNow({ force: true })}
      title="Tap to sync now"
    >
      {tag}
    </button>
  );
}
